import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BulkUploadService {
  // eslint-disable-next-line @typescript-eslint/type-annotation-spacing
  constructor(private http: HttpClient) { }
  private postUpdated = new Subject<{ posts: any[]; postCount: number }>();
  private posts: any[] = [];

  private BACKEND_URL = 'displayRegisteredUsers/';

  getPosts(postPerPage: number, currentPage: number, role: string, filterObject: object) {
    let userPageData = { "postPerPage": postPerPage, "currentPage": currentPage, "role": role, "filterObject": filterObject }
    this.http
      .post(`${environment.apiUrl}${this.BACKEND_URL}${role}/?api=core`, userPageData)
      .pipe(
        map((data: any) => {
          return {
            posts: data.posts.map((post: any) => {
              return {
                fname: post.fname,
                lname: post.lname,
                pfname: post.pfname,
                plname: post.plname,
                email: post.email,
                mobile: post.mobile,
                username: post.username,
                parentEmail: post.parentEmail,
                schoolName: post.SchoolData ? post.SchoolData.name : "",
                schoolGrade: post.schoolGrade,
                courseLevel: post.role === 'tutor' ? (
                  post && post.MultiCourseData && Array.isArray(post.MultiCourseData) && post.MultiCourseData.length > 0 ?
                    post.MultiCourseData.map((course: any) => course.course_level).join(', ') :
                    'All'
                ) : (post.CourseData ? post.CourseData.course_level : ""),
                role: post.role,
                dob: post.dob,
                status: post.metadata.status,
                userId: post._id
              };
            }),
            maxPosts: data.maxPosts,
          };
        })
      )
      .subscribe((tranformedPostData) => {
        this.posts = tranformedPostData.posts;
        this.postUpdated.next({
          posts: [...this.posts],
          postCount: tranformedPostData.maxPosts,
        });
      });
  }

  getPostEventListener() {
    return this.postUpdated.asObservable();
  }

  downloadUsersData(userFilter: object, role: string) {
    let userFilterData = { "userFilter": userFilter }
    return this.http.post(`${environment.apiUrl}downloadUsersData/${role}/?api=core`, userFilterData, { responseType: 'blob' })
  }
}
